export interface PolygonCoords {
    lat: number;
    lng: number;
}

export interface GoogleMapPolygons {
    color: string,
    paths: PolygonCoords[];
}

export interface PlaceData {
    formatted_address: string,
    geometry?: {
        location?: {
            lat: number,
            lng: number;
        },
        viewport?: {
            east: number,
            north: number,
            south: number,
            west: number;
        };
    },
    name: string;
}

export const isGoogleAddress = (data: any): data is PlaceData => {
    return typeof data == 'object' && 'formatted_address' in data;
};

export const mapsPlaceToPlaceData = (data: google.maps.places.PlaceResult): PlaceData => {
    return {
        formatted_address: data.formatted_address ?? 'Non-spécifié',
        geometry: {
            location: data.geometry?.location?.toJSON(),
            viewport: data.geometry?.viewport?.toJSON()
        },
        name: data.name ?? 'Non-spécifié'
    };
};
